function triggerEdapEvent(trackingContext, text) {
    const field = {
        action_location: 'above-header',
        placement_type: 'banner'
    };
    trackingContext.trigger(`native_adoption_placement.${text}`, field);
}

export {triggerEdapEvent};
